export default __webpack_public_path__ + "77883f5c23372e9b43e1dd6f20a1fbff.jpg";